import { render, staticRenderFns } from "./AstaLogs.vue?vue&type=template&id=cdabe5fc&scoped=true&"
import script from "./AstaLogs.vue?vue&type=script&lang=js&"
export * from "./AstaLogs.vue?vue&type=script&lang=js&"
import style0 from "./AstaLogs.vue?vue&type=style&index=0&id=cdabe5fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdabe5fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdabe5fc')) {
      api.createRecord('cdabe5fc', component.options)
    } else {
      api.reload('cdabe5fc', component.options)
    }
    module.hot.accept("./AstaLogs.vue?vue&type=template&id=cdabe5fc&scoped=true&", function () {
      api.rerender('cdabe5fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AstaLogs.vue"
export default component.exports